import { PageLayout, Content } from "aldoo-ra/Layouts"
import { usePageContext } from "vike-react/usePageContext"
import Localization from "aldoo-ra/Localization"
import Navbar from "../Navbar"
import Footer from "../Footer"
import AldooStore from "aldoo-ra/Store"
import UpgradePromptDialogProvider from "@components/UpgradePromptDialog"

export default function Site({ children }) {
  const pageContext = usePageContext()
  const currentPath = pageContext?.urlPathname || (typeof window !== "undefined" ? window.location.pathname : "/")
  const { currentLanguage } = Localization()
  const localeRoot = currentLanguage && currentLanguage !== "en" ? `/${currentLanguage}` : "/"
  const isHome = currentPath === localeRoot || currentPath === localeRoot + "/"

  return (
    <PageLayout>
      <Navbar />
      <Content>{children}</Content>
      {!isHome && <Footer />}
      <AldooStore />
      <UpgradePromptDialogProvider />
    </PageLayout>
  )
}
